import styled from "@emotion/styled"
import Img from "gatsby-image"

const Fluid = styled(Img)`
  height: auto;
  vertical-align: top;
  max-width: 100%;
`

const Round = styled(Img)`
  border-radius: 50%;
  vertical-align: top;
`

export { Fluid, Round }
